import React, { useEffect, useRef } from "react";
import CustomImage from "../../CustomImage";
import styles from "./DelegatesSection.module.scss";
interface Props {
  universitydata: any;
  univertitle: any;
  universitybackcolor: any;
}

const DelegatesSection: React.FC<Props> = ({ universitydata, univertitle, universitybackcolor }) => {
  return (
    <>
      <div className={styles.delegatesSection} style={{ backgroundColor: universitybackcolor || "#F2F8FF" }}>
        <div className={styles.sectionContainer}>
          <div className={styles.sectionHeading}>
            <h2>{univertitle}</h2>
          </div>
        </div>
        <div className={styles.sectionContainer}>
          <div className={styles.cardsGrid}>
            {universitydata?.length > 0 &&
              universitydata.map((universitydetails: any, index: number) => {
                return (
                  <div key={index} className={styles.cardWrapper}>
                    <div className={styles.universityCard}>
                      <div className={styles.cardImageWrapper}>
                        <CustomImage
                          src={universitydetails?.cardImage?.imageUrl || "/images/admissionsday/universitya.png"}
                          width={260}
                          height={220}
                          className={styles.cardImage}
                          alt="University-Representative.png"
                        />
                      </div>
                      <div className={styles.cardBody}>
                        <div className={styles.universityName}>
                          <h4>{universitydetails?.cardUniversityName?.label}</h4>
                        </div>
                        <div className={styles.universitySubtitle}>
                          <h4>{universitydetails?.cardUniversityName?.value}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};
export default DelegatesSection;
